import { type ReactNode } from "react";
import { StyledFlexbox } from "./MainContainer.styles";

const Container = ({
  children,
  testId,
}: {
  children: ReactNode;
  testId?: string;
}) => {
  return (
    <StyledFlexbox
      flexDirection="column"
      // alignItems="center"
      data-testid={testId}
    >
      {children}
    </StyledFlexbox>
  );
};

export default Container;
